/**
 * Crop an image using canvas given crop pixel area and output size.
 * Returns a Blob (WEBP by default).
 *
 * @param {string} imageSrc - URL or data URL of the image
 * @param {{x:number,y:number,width:number,height:number}} cropPixels - Cropped area in original image pixels
 * @param {number} outputWidth - Target output width (default 960)
 * @param {number} outputHeight - Target output height (default 1280)
 * @param {string} mime - Output mime type (default 'image/webp')
 * @param {number} quality - Output quality 0..1 (default 0.9)
 * @returns {Promise<Blob>}
 */
export async function getCroppedImg(imageSrc, cropPixels, outputWidth = 960, outputHeight = 1280, mime = 'image/webp', quality = 0.9) {
  const image = await loadImage(imageSrc);

  const canvas = document.createElement('canvas');
  canvas.width = outputWidth;
  canvas.height = outputHeight;
  const ctx = canvas.getContext('2d');

  // Draw the selected crop area scaled into output canvas
  ctx.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    outputWidth,
    outputHeight
  );

  return await new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob);
        else reject(new Error('Canvas is empty'));
      },
      mime,
      quality
    );
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // Allow local blob: URLs
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = src;
  });
}
